import { Download, Folder, Home, RefreshCw, Settings, Briefcase } from 'react-feather';

export const MENUITEMSFR = [
  {
    Items: [
      {
        title: 'Projets',
        icon: Folder,
        badge: 'badge badge-success',
        active: false,
        path: `/project/list`,
        type: 'link',
      },
      {
        title: 'tpe.title',
        icon: Briefcase,
        badge: 'badge badge-success',
        active: false,
        path: `/tpe/list`,
        type: 'link',
      },
      {
        title: 'production_cycle.list',
        icon: RefreshCw,
        badge: 'badge badge-success',
        active: false,
        path: `/settings/production-cycle`,
        type: 'link',
      },
      {
        title: 'Paramètres',
        icon: Settings,
        type: 'sub',
        badge: 'badge badge-success',
        active: false,
        children: [
          {
            title: 'Activités',
            icon: Home,
            type: 'sub',
            badge: 'badge badge-success',
            active: false,
            children: [
              {
                path: `/settings/activity`,
                title: 'Liste d’activités',
                type: 'link',
              },
              {
                path: `/settings/sub-activity`,
                title: 'Liste des sous-activités',
                type: 'link',
              },
              {
                path: `/settings/production`,
                title: 'Liste des productions',
                type: 'link',
              },
            ],
          },
          {
            title: 'Unités de référence',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/unit',
          },
          {
            title: 'Nature des charges',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/nature-charge',
          },
          {
            title: 'Nature des produits',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/nature-product',
          },
          {
            title: 'Devises',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/currency',
          },
          {
            title: 'Localités',
            icon: Home,
            type: 'sub',
            badge: 'badge badge-success',
            active: false,
            children: [
              {
                path: `/settings/locality/country`,
                title: 'Liste des pays',
                type: 'link',
              },
              {
                path: `/settings/locality/region`,
                title: 'Liste des régions',
                type: 'link',
              },
              {
                path: `/settings/locality/departement`,
                title: 'Liste des départements',
                type: 'link',
              },
              {
                path: `/settings/locality/commune`,
                title: 'Liste des communes',
                type: 'link',
              },
              {
                path: `/settings/locality/village`,
                title: 'Liste des villages',
                type: 'link',
              },
            ],
          },
          {
            title: 'Pratiques agroécologiques',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/practice',
          },
        ],
      },
      {
        title: 'export',
        icon: Download,
        badge: 'badge badge-success',
        active: false,
        path: `/export`,
        type: 'link',
      },
    ],
  },
];

export const MENUITEMSEN = [
  {
    Items: [
      {
        title: 'Projects',
        icon: Folder,
        type: 'link',
        badge: 'badge badge-success',
        active: false,
        path: `/project/list`,
      },
      {
        title: 'tpe.title',
        icon: Briefcase,
        type: 'link',
        badge: 'badge badge-success',
        active: false,
        path: `/tpe/list`,
      },
      {
        title: 'production_cycle.list',
        icon: RefreshCw,
        type: 'link',
        badge: 'badge badge-success',
        active: false,
        path: `/settings/production-cycle`,
      },
      {
        title: 'Settings',
        icon: Settings,
        type: 'sub',
        badge: 'badge badge-success',
        active: false,
        children: [
          {
            title: 'Activities',
            icon: Home,
            type: 'sub',
            badge: 'badge badge-success',
            active: false,
            children: [
              {
                path: `/settings/activity`,
                title: 'Types of activities',
                type: 'link',
              },
              {
                path: `/settings/sub-activity`,
                title: 'List of sub-activities',
                type: 'link',
              },
              {
                path: `/settings/production`,
                title: 'List of productions',
                type: 'link',
              },
            ],
          },
          {
            title: 'Reference units',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/unit',
          },
          {
            title: 'Nature of charges',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/nature-charge',
          },
          {
            title: 'Nature of products',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/nature-product',
          },
          {
            title: 'Currencies',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/currency',
          },
          {
            title: 'Localities',
            icon: Home,
            type: 'sub',
            badge: 'badge badge-success',
            active: false,
            children: [
              {
                path: `/settings/locality/country`,
                title: 'List of countries',
                type: 'link',
              },
              {
                path: `/settings/locality/region`,
                title: 'List of regions',
                type: 'link',
              },
              {
                path: `/settings/locality/departement`,
                title: 'List of departments',
                type: 'link',
              },
              {
                path: `/settings/locality/commune`,
                title: 'List of communes',
                type: 'link',
              },
              {
                path: `/settings/locality/village`,
                title: 'List of villages',
                type: 'link',
              },
            ],
          },
          {
            title: 'Agroecological practices',
            icon: Home,
            type: 'link',
            badge: 'badge badge-success',
            path: '/settings/practice',
          },
        ],
      },
      {
        title: 'export',
        icon: Download,
        badge: 'badge badge-success',
        active: false,
        path: `/export`,
        type: 'link',
      },
    ],
  },
];
